import script from "./VitaInfoModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./VitaInfoModal.vue?vue&type=script&lang=ts&setup=true"

import "./VitaInfoModal.vue?vue&type=style&index=0&id=3ea26246&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ea26246"]])

export default __exports__